import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { CLIENT_TYPES } from "@/data/company";

const SERVICES = [
  "Maçonnerie générale", "Rénovation & réhabilitation", "Béton & ouvrages structurels",
  "Murs & clôtures", "VRD & aménagements extérieurs", "Finitions & reprises", "Autre / je ne sais pas",
];

export default function CallbackForm({ defaultService = "", dark = false, source = "formulaire" }) {
  const [form, setForm] = useState({
    name: "", phone: "", email: "", service: defaultService,
    client_type: "particuliers", preferred_time: "", message: "",
  });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast.error("Nom et téléphone sont requis."); return; }
    setLoading(true);
    try {
      await api.post("/leads", { ...form, source });
      toast.success("Demande envoyée ! Nous vous rappelons très vite.");
      setForm({ name: "", phone: "", email: "", service: defaultService, client_type: "particuliers", preferred_time: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const label = dark ? "text-white/70" : "text-ink/70";
  const field = `w-full rounded-lg border px-4 py-3 text-sm outline-none transition-colors focus:ring-2 focus:ring-primary ${
    dark ? "bg-white/10 border-white/20 text-white placeholder-white/40" : "bg-white border-border text-ink placeholder-ink/40"
  }`;

  return (
    <form onSubmit={submit} data-testid="callback-form" className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={`text-xs font-semibold ${label}`}>Nom *</label>
          <input data-testid="callback-name" className={field} value={form.name} onChange={set("name")} placeholder="Votre nom" />
        </div>
        <div>
          <label className={`text-xs font-semibold ${label}`}>Téléphone *</label>
          <input data-testid="callback-phone" className={field} value={form.phone} onChange={set("phone")} placeholder="06 XX XX XX XX" />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={`text-xs font-semibold ${label}`}>Email</label>
          <input data-testid="callback-email" className={field} value={form.email} onChange={set("email")} placeholder="email@exemple.fr" />
        </div>
        <div>
          <label className={`text-xs font-semibold ${label}`}>Vous êtes</label>
          <select data-testid="callback-client-type" className={field} value={form.client_type} onChange={set("client_type")}>
            {CLIENT_TYPES.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
          </select>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={`text-xs font-semibold ${label}`}>Service concerné</label>
          <select data-testid="callback-service" className={field} value={form.service} onChange={set("service")}>
            <option value="">Sélectionnez…</option>
            {SERVICES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label className={`text-xs font-semibold ${label}`}>Moment de rappel souhaité</label>
          <input data-testid="callback-time" className={field} value={form.preferred_time} onChange={set("preferred_time")} placeholder="Ex : matin, après 18h…" />
        </div>
      </div>
      <div>
        <label className={`text-xs font-semibold ${label}`}>Votre projet</label>
        <textarea data-testid="callback-message" rows={3} className={field} value={form.message} onChange={set("message")} placeholder="Décrivez brièvement votre besoin…" />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid="callback-submit"
        className="w-full inline-flex items-center justify-center gap-2 bg-primary text-white font-bold px-6 py-3.5 rounded-full hover:brightness-95 transition disabled:opacity-60"
      >
        {loading ? <Loader2 className="animate-spin" size={18} /> : <Send size={18} />}
        Être rappelé gratuitement
      </button>
    </form>
  );
}
